import { render, staticRenderFns } from "./downloadPage.vue?vue&type=template&id=c5df9458"
import script from "./downloadPage.vue?vue&type=script&lang=js"
export * from "./downloadPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports